import style from "./account.module.scss";
import packageJson from "../../../package.json";
import { useMsal } from "@azure/msal-react";

const version = packageJson.version;

const Logout = () => {
  const { instance } = useMsal();

  const handleLogout = () => {
    localStorage.removeItem("tgt");
    localStorage.removeItem("lastVisited");

    instance
      .logoutRedirect()
      .then((response) => {
        console.log(response);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  return (
    <div className={style.logout}>
      <button className={style.logoutButton} onClick={handleLogout}>
        Logout
      </button>
      <p className={style.version}>v&nbsp;{version}</p>
    </div>
  );
};

export default Logout;
